import React from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import block from 'bem-cn'

import { MODAL_ROUTE_URLS } from 'router/modalRoutes'

import { useForgotPassword } from 'modules/Emails/hooks'

import { selectLocaleDict } from 'features/locale/selectors'

import { useModalContext } from '@bcraft-frontend-lib/core'

import { ModalWrapper } from 'components/ModalWrapper'
import { ButtonSizes, Form, FormInput } from 'components/UIKit'
import Button from 'components/UIKit/Button/Button'

import './ForgotPasswordModal.scss'

export type ForgotPasswordModalProps = {
  path: string
}

const b = block('forgot-password-modal')

export const ForgotPasswordModal: React.FC<ForgotPasswordModalProps> = ({ path }) => {
  const { closeModal, replaceLastModal } = useModalContext()

  const onClose = () => {
    closeModal(path)()
  }

  const { isLoading, formik } = useForgotPassword({ onSuccess: replaceLastModal(MODAL_ROUTE_URLS.CHECK_YOUR_EMAIL()) })

  const locale = useSelector(selectLocaleDict, shallowEqual).auth

  return (
    <ModalWrapper title={locale.forgotPassword} className={b()} onClose={onClose} hideLogo>
      <Form formik={formik} className={b('form')}>
        <FormInput type="email" name="email" caption={locale.email} placeholder={locale.yourEmail} />
        <Button type="submit" text={locale.send} loading={isLoading} fullWidth size={ButtonSizes.MODAL} />
      </Form>
    </ModalWrapper>
  )
}
